(function () {
  if (customElements.get('product-shipping-bar')) return;

  class ProductShippingBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10);
      this.deficitTemplate = this.dataset.deficitTemplate || '';
      this.successText = this.dataset.successText || '';
      this.moneySuffix = this.dataset.moneySuffix || '';
      this.fill = this.querySelector('[data-shipping-fill]');
      this.status = this.querySelector('[data-shipping-status]');
      this.track = this.querySelector('[role="progressbar"]');

      if (!this.threshold || !this.fill || !this.status) return;

      this.onCartChange = this.onCartChange.bind(this);
      document.addEventListener('on:cart:add', this.onCartChange);
      document.addEventListener('on:line-item:change', this.onCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener('on:cart:add', this.onCartChange);
      document.removeEventListener('on:line-item:change', this.onCartChange);
    }

    onCartChange(event) {
      var cart = event.detail && event.detail.cart;
      if (!cart || typeof cart.total_price !== 'number') return;
      this.update(cart.total_price);
    }

    update(totalCents) {
      var progress = Math.min((totalCents / this.threshold) * 100, 100);
      this.fill.style.width = progress + '%';
      if (this.track) this.track.setAttribute('aria-valuenow', Math.round(progress));

      if (totalCents >= this.threshold) {
        this.status.textContent = this.successText;
        this.classList.add('is-complete');
      } else {
        var deficit = this.threshold - totalCents;
        this.status.innerHTML = this.deficitTemplate.replace(
          '[amount]',
          '<strong>' + this.formatMoney(deficit) + '</strong>'
        );
        this.classList.remove('is-complete');
      }
    }

    // NOTE: formatting is RON-only by design (ro-RO grouping + the "lei" suffix
    // supplied via data-money-suffix). Revisit if the store sells in other currencies.
    formatMoney(cents) {
      var value = cents / 100;
      try {
        return new Intl.NumberFormat('ro-RO', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value) + this.moneySuffix;
      } catch (e) {
        return value.toFixed(2).replace('.', ',') + this.moneySuffix;
      }
    }
  }

  customElements.define('product-shipping-bar', ProductShippingBar);
})();
